import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logo-header',
  templateUrl: './logo-header.component.html',
  styleUrls: ['./logo-header.component.css']
})
export class LogoHeaderComponent implements OnInit {

  channelIdCache = '';
  env:string = environment.baseUrl;

  constructor() { }

  ngOnInit(): void {
    this.channelIdCache = localStorage.getItem('wl_content_provider_id');
  }

  showLogoHeader = false;
  showStickyHeader = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const heroSection = document.querySelector('.hero-section') as HTMLElement;
  
    if (heroSection) {
      const heroHeight = heroSection.offsetHeight;
      this.showLogoHeader = scrollTop > 50;
      this.showStickyHeader = scrollTop > heroHeight - 100; 
    }
  }
}
